import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Xamarin = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M16 8h-2l-2 4-2-4H8l2 4-2 4h2l2-4 2 4h2l-2-4 2-4Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="M21.794 12.771a1.584 1.584 0 0 0 0-1.562L17.559 3.77C17.284 3.316 16.755 3 16.225 3h-8.47c-.55 0-1.079.316-1.334.771L2.206 11.21a1.586 1.586 0 0 0 0 1.562L6.42 20.21c.275.474.805.791 1.334.791h8.45a1.54 1.54 0 0 0 1.334-.791l4.255-7.438ZM8.024 5h7.934l3.979 6.99-4.01 7.01H8.034l-3.973-7.01L8.024 5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Xamarin;
